module.exports = __webpack_public_path__ + "img/DSC_0023.b72f2a31.jpg";